/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";

type State = {
    value: boolean;
};

type States = {
    [toggleName: string]: State;
}

type ToggleName<T> = T;

type Action<T> = {
    toggleName: ToggleName<T>;
    value?: boolean;
};

const reducer = <T extends string>(state: States, action: Action<T>) => ({
    ...state,
    [action.toggleName]: {
        ...state[action.toggleName],
        value: action.value !== undefined ? action.value : !state[action.toggleName].value
    }
});

export default function useToggle<T extends string>(...toggleNames: ToggleName<T>[]) {
    const initialState = toggleNames.reduce(
        (state, dialog) => ({ ...state, [dialog]: { value: false } }),
        {} as States);
    const [state, dispatch] = React.useReducer(reducer, initialState);

    return {
        isOn(toggleName: ToggleName<T>) {
            return state[toggleName].value;
        },

        toggle(toggleName: ToggleName<T>) {
            dispatch({ toggleName })
        },

        on(toggleName: ToggleName<T>) {
            dispatch({ toggleName, value: true })
        },

        off(toggleName: ToggleName<T>) {
            dispatch({ toggleName, value: false })
        }
    }
}